import { Layout, Menu, Tooltip } from "antd";
import { SiderMenuItem } from "./SiderMenu.default";
import { useEffect, useState } from "react";

export interface SiderMenuProps {
  readonly selectedKey?: string | null;
  readonly items: SiderMenuItem[];
  readonly onSelect?: (key: string) => void;
}

function SiderMenu(props: SiderMenuProps) {
  const [collapsed, setCollapsed] = useState(true);
  const [selectKey, setSelectKey] = useState<string | null>(null);
  const [openKey, setOpenKey] = useState<string | null>(null);

  useEffect(() => {
    setSelectKey(props.selectedKey ?? null);
  }, [props.selectedKey]);

  useEffect(() => {
    if (!openKey && !collapsed) {
      const selectItem = props.items.find((item) =>
        item.children?.some((item) => item.key === selectKey),
      );
      setOpenKey(selectItem?.key ?? null);
    }
  }, [selectKey, collapsed]);

  function onOpenChange(openKeys: string[]): void {
    setOpenKey(openKeys.reverse().find(() => true)!);
  }

  function onSelect(e: {
    readonly key: string;
    readonly keyPath: string[];
  }): void {
    setSelectKey(e.key);

    props.onSelect?.(e.key);
  }

  function onMenuToggle(collapsed: boolean): void {
    setCollapsed(collapsed);
  }

  // Methods

  function mapItems(items: SiderMenuItem[]) {
    return items.map((item) => ({
      ...item,
      icon: (
        <>
          {collapsed && (
            <Tooltip title={item.label} placement={"right"}>
              {item.icon}
            </Tooltip>
          )}
          {!collapsed && <>{item.icon}</>}
        </>
      ),
    }));
  }

  return (
    <Layout.Sider collapsible collapsed={collapsed} onCollapse={onMenuToggle}>
      <Menu
        className="border-none bg-transparent"
        mode="inline"
        inlineCollapsed={collapsed}
        triggerSubMenuAction={"click"}
        openKeys={openKey ? [openKey] : []}
        selectedKeys={selectKey ? [selectKey] : []}
        items={mapItems(props.items)}
        onOpenChange={onOpenChange}
        onSelect={onSelect}
      ></Menu>
    </Layout.Sider>
  );
}

export default SiderMenu;
